module.exports = __webpack_public_path__ + "img/DiferenciaHoraPanel.0f921488.svg";